<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="type=='detail'?'留言详情':'回复留言'"
                :visible.sync="show"
                width="600px"
                top="30px">
            <div v-loading="loading">
                <div class="w100 pl20 pr20">
                    <el-form label-width="100px" :model="form"  ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="留言人" style="min-width: 250px;">
                            <el-input v-model="form.createUser"  readonly></el-input>
                        </el-form-item>
                        <!--<el-form-item label="留言时间" style="min-width: 250px;">-->
                            <!--<el-input v-model="form.createTime"  readonly></el-input>-->
                        <!--</el-form-item>-->
                        <el-form-item label="所涉服务" v-if="type=='detail'" style="min-width: 250px;">
                            <el-input v-model="form.serveName"  readonly></el-input>
                        </el-form-item>
                        <el-form-item label="所涉部门" v-if="type=='detail'" style="min-width: 250px;">
                            <el-input v-model="form.belongDeptName"  readonly></el-input>
                        </el-form-item>
                        <el-form-item label="留言详情"  style="min-width: 250px;">
                            <div class="msg-detail">
                                <div class="msg-item cl-f other">
                                    <div class="str-warp">
                                        <div>{{form.createUser+': '+form.createTime}}</div>
                                        <div class="msg-str">{{form.content}}</div>
                                    </div>
                                </div>
                                <div class="msg-item cl-f self" v-if="form.answer">

                                    <div class="str-warp">
                                        <div>{{form.answerUser+': '+form.answerTime}}</div>
                                        <div class="msg-str">{{form.answer}}</div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="type=='answer'" :label="form.answer?'追加回复':'回复内容'"
                                      style="min-width: 250px;">
                            <el-input rows="5" v-model="form.contents"
                                      @keyup.enter.native="submitForm('ruleForm')"
                                      type="textarea" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>

                </div>

            </div>
            <div slot="footer" v-if="type=='answer'" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        messageAnswerAddAndEdit,
        getServeLeaveMessageInfo
    } from '@/api/managementCenter/advices'
    export default {
        name: "answerMsgDialog",
        components: {},
        props: [],
        data() {
            return {
                 data:{},
                type:'',
                show: false,
                loading: false,
                msgList:[],
                form: {},
                param:{},

            };
        },
        computed: {

        },
        methods: {
            // 显示弹框
            dialogShow(type,data) {
                this.type=type;
                this.data=data;
                this.show = true;
                this.$nextTick(()=>{
                    this.getServeLeaveMessageInfo();
                })
                // this.$nextTick(()=>{
                //     this.param={msgId:data.msgId};
                //     this.form.msgId = data.msgId
                //     this.form.serveId = data.serveId
                //     this.form.answerBy = this.$store.getters.userData.userName
                //     this.nowTime =utils.dateFormat((new Date()).getTime());
                //     this.getLeaveMsgDetail()
                // })

            },
            getServeLeaveMessageInfo(){
                this.loading = true;
                getServeLeaveMessageInfo(this.data.id).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.form=data.data||{}
                        this.$nextTick(() => {
                            // let container = this.$el.querySelector(".msg-detail");
                            // container.scrollTop = container.scrollHeight;
                        });
                    }else{
                        this.$message.warning( data.msg||"获取留言信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })


            },
            messageAnswerAddAndEdit(){
                this.loading = true;
                const params={
                    content:this.form.contents,
                    msgId:this.data.id,
                    serveId:this.data.serveId
                }

                messageAnswerAddAndEdit(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "回复成功!" );
                        this.$emit('saveSuccess')
                        this.getServeLeaveMessageInfo();
                    }else{
                        this.$message.warning(  data.msg||"回复失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                if (!this.form.contents) {
                    this.$message.warning("请输入要回复的内容!");
                    return;
                }

                this.messageAnswerAddAndEdit()
            }
        },
        watch: {
            show(val){
                if(!val){

                    this.form.contents=''
                }

            }

        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .msg-detail{
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 200px;
        overflow: auto;
        background: #F2F4F5;
        padding: 20px 0;
        .msg-item{
            padding: 2px 10px ;
            font-size: 12px;

            .msg-str{
                display: inline-block;
                max-width: 60%;
                padding:5px 10px ;
                border-radius:6px;
                line-height: 20px;

            }
        }
        .other{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: left;
                padding-left: 5px;
            }
            .str-warp{
                text-align: left;
                .msg-str{
                    background: #fff;
                    position: relative;
                    margin-left: 3px;
                    &:before{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-right: 8px solid #fff;
                        left: -13px;


                    }
                }
            }

        }
        .self{
            .name-warp{
                margin-top: 10px;
                height: 20px;
                line-height: 20px;
                text-align: right;
                padding-right: 5px;
            }
            .str-warp{
                text-align: right;
                .msg-str{
                    background: #8CE050;
                    color: #fff;
                    position: relative;
                    margin-right: 3px;
                    &:after{
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        top: 5px;
                        border-left: 8px solid #8CE050;
                        right: -13px;

                    }



                }

            }

        }


    }


</style>
